import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll() {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: '/accounts',
      }))
  );
}

async function getById(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/accounts/${accountID}`
      }))
  );
}

async function getDealers() {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: '/accounts/dealers'
      }))
  );
}

async function create(account) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/accounts',
        body: JSON.stringify(account)
      }))
  );
}

async function update(account) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/accounts/${account.accountID}`,
        body: JSON.stringify(account)
      }))
  );
}

// lowercase delete is a reserved word in javascript
async function Delete(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/accounts/${accountID}`
      }))
  );
}

const accountService = {
  getAll,
  getById,
  getDealers,
  create,
  update,
  delete: Delete
};

export default accountService;
